//import { Injectable } from '@angular/core';
//import { AppConsts } from '@shared/AppConsts';


//@Injectable()
//export class AppAuthService {

//    logout(reload?: boolean): void {
//        abp.auth.clearToken();
//		abp.utils.setCookieValue(AppConsts.authorization.encryptedAuthTokenName, undefined, undefined, abp.appPath);
//        if (reload !== false) {
//            location.href = AppConsts.appBaseUrl;
//        }
//    }
//}

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConsts } from '@shared/AppConsts';

@Injectable()
export class AppAuthService {

    constructor(
        private http: HttpClient
    ) {
    }

    //logout(reload?: boolean): void {

    //    this.http.get('/api/TokenAuth/LogOutUser')
    //        .subscribe({
    //            next: (res) => {
    //                console.log('Logout API success response:', res);
    //                this.doLogout(reload);
    //            },
    //            error: (err) => {
    //                console.error('Logout API error:', err);
    //                this.doLogout(reload);
    //            }
    //        });
    //}

    logout(reload?: boolean): void {

        const deviceId = localStorage.getItem('deviceId');

        

        this.http.post('/api/TokenAuth/LogOutUser', {
            deviceId: deviceId
        }).subscribe({
            next: () => {
                this.doLogout(reload);
            },
            error: () => {
                this.doLogout(reload);
            }
        });
    }



    private doLogout(reload?: boolean): void {

        // existing logout logic (unchanged)
        abp.auth.clearToken();

        abp.utils.setCookieValue(
            AppConsts.authorization.encryptedAuthTokenName,
            undefined,
            undefined,
            abp.appPath
        );

        if (reload !== false) {
            location.href = AppConsts.appBaseUrl;
        }
    }
}
